
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface KolAvatarGroupProps {
  users: Array<{
    name: string;
    image?: string;
  }>;
  limit?: number;
  size?: 'sm' | 'md' | 'lg';
}

const KolAvatarGroup: React.FC<KolAvatarGroupProps> = ({ 
  users, 
  limit = 5,
  size = 'md'
}) => {
  const displayUsers = limit ? users.slice(0, limit) : users;
  const remaining = users.length - displayUsers.length;

  // Size mapping
  const sizeClasses = {
    sm: { avatar: 'h-6 w-6', container: '-space-x-1', text: 'text-xs' },
    md: { avatar: 'h-8 w-8', container: '-space-x-2', text: 'text-sm' },
    lg: { avatar: 'h-10 w-10', container: '-space-x-3', text: 'text-base' }
  };

  return (
    <TooltipProvider>
      <div className={`flex items-center ${sizeClasses[size].container}`}>
        <ScrollArea className="flex">
          <div className="flex">
            {displayUsers.map((user, i) => (
              <Tooltip key={i}>
                <TooltipTrigger asChild>
                  <Avatar className={`${sizeClasses[size].avatar} border-2 border-background`}>
                    {user.image ? (
                      <AvatarImage src={user.image} alt={user.name} />
                    ) : (
                      <AvatarFallback className={sizeClasses[size].text}>
                        {user.name.split(' ').map(n => n[0]).join('').toUpperCase()}
                      </AvatarFallback>
                    )}
                  </Avatar>
                </TooltipTrigger>
                <TooltipContent side="bottom">
                  <p>{user.name}</p>
                </TooltipContent>
              </Tooltip>
            ))}
          </div>
        </ScrollArea>
        
        {remaining > 0 && (
          <span className={`${sizeClasses[size].avatar} flex items-center justify-center rounded-full bg-muted text-muted-foreground ${sizeClasses[size].text}`}>
            +{remaining}
          </span>
        )}
      </div>
    </TooltipProvider>
  );
};

export default KolAvatarGroup;
